import { Button, ButtonGroup, styled } from '@mui/material';
import { ConnectCandidateMatchArchiveDashboardDataTestIds } from 'data-testids/CandidatePortalDataTestIds';
import {
  MatchArchiveFilterButtonLabels,
  MatchArchiveFilterTypes,
} from 'features/Connect/features/ConnectCandidatePortalDashboards/CandidateMatchArchiveDashboard/utils/constants';
import { MatchArchiveFilterButtonGroupProps } from 'features/Connect/features/ConnectCandidatePortalDashboards/CandidateMatchArchiveDashboard/utils/types';

export const MatchArchiveFilterButtonGroup: React.FC<MatchArchiveFilterButtonGroupProps> = ({
  activeFilter,
  onFilterChange,
  hasAcceptedMatches = true,
  hasRejectedMatches = true,
}) => {
  return (
    <StyledButtonGroup
      variant="outlined"
      aria-label="filter button group"
      data-testid={ConnectCandidateMatchArchiveDashboardDataTestIds.FILTER_BUTTON_GROUP}
    >
      <StyledFilterButton
        variant={activeFilter === MatchArchiveFilterTypes.ALL ? 'contained' : 'outlined'}
        onClick={() => onFilterChange(MatchArchiveFilterTypes.ALL)}
        isActive={activeFilter === MatchArchiveFilterTypes.ALL}
        data-testid={ConnectCandidateMatchArchiveDashboardDataTestIds.FILTER_ALL_BUTTON}
      >
        {MatchArchiveFilterButtonLabels.ALL}
      </StyledFilterButton>
      <StyledFilterButton
        variant={activeFilter === MatchArchiveFilterTypes.INTERESTED ? 'contained' : 'outlined'}
        onClick={() => onFilterChange(MatchArchiveFilterTypes.INTERESTED)}
        isActive={activeFilter === MatchArchiveFilterTypes.INTERESTED}
        disabled={!hasAcceptedMatches}
        data-testid={ConnectCandidateMatchArchiveDashboardDataTestIds.FILTER_INTERESTED_BUTTON}
      >
        {MatchArchiveFilterButtonLabels.INTERESTED}
      </StyledFilterButton>
      <StyledFilterButton
        variant={activeFilter === MatchArchiveFilterTypes.NO_THANKS ? 'contained' : 'outlined'}
        onClick={() => onFilterChange(MatchArchiveFilterTypes.NO_THANKS)}
        isActive={activeFilter === MatchArchiveFilterTypes.NO_THANKS}
        disabled={!hasRejectedMatches}
        data-testid={ConnectCandidateMatchArchiveDashboardDataTestIds.FILTER_NO_THANKS_BUTTON}
      >
        {MatchArchiveFilterButtonLabels.NO_THANKS}
      </StyledFilterButton>
    </StyledButtonGroup>
  );
};

const StyledButtonGroup = styled(ButtonGroup)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    width: '100%',
    '& .MuiButtonGroup-grouped': {
      flex: 1,
    },
  },
}));

const StyledFilterButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  textTransform: 'none',
  fontWeight: 500,
  padding: theme.spacing(1, 2),
  minWidth: '80px',
  maxHeight: '40px',
  backgroundColor: isActive ? theme.palette.primary.main : 'transparent',
  color: isActive ? 'white' : theme.palette.text.primary,
  borderColor: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: isActive ? theme.palette.primary.dark : 'transparent',
  },
  '&:disabled': {
    backgroundColor: 'transparent',
    color: theme.palette.text.disabled,
    borderColor: theme.palette.text.disabled,
    cursor: 'not-allowed',
  },
  [theme.breakpoints.down('md')]: {
    whiteSpace: 'nowrap',
    minWidth: 'auto',
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
